<template>
    <div :style="{'width': width, 'min-width':minWidth, 'max-width' : maxWidth}" class="container">
        <div class="card" :style="{'margin': margin, 'padding' : padding, 'background' : background}" :class="{'selectable':selectable}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TqCard",
        props:{
            width: {
                type: String
            },
            margin: {
                type: String
            },
            minWidth:{
                type: String
            },
            maxWidth:{
                type: String
            },
            padding :{
                type : String
            },
            selectable:{
                type: Boolean
            },
            background:{
                type : String
            }
        }
    }
</script>

<style scoped lang="scss">

    .container{
        display: inline-block;
        vertical-align: top;
        /*text-align: left;*/

        .card{
            background: white;
            box-shadow: 0 6px 12px 1px rgba(0,0,0,0.2);
            transition: 0.3s;
            border-radius: 5px;
            display: flow-root;
            /*border: 1px solid black;*/

            &.selectable{
                cursor: pointer;
                &:hover {
                    box-shadow: 8px 8px 16px 8px rgba(0,0,0,0.2);
                }
            }
        }
    }



</style>
